import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from './base.service';
import {Observable} from 'rxjs';
import {AlertService} from './alert.service';
import {GlobalService} from './global.service';
import {AppUrl} from '../constants/app-url';
import {UploadService} from './upload.service';

@Injectable({
    providedIn: 'root'
})
export class ArticleCategoryService extends BaseService {
    constructor(public http: HttpClient,
                public alertService: AlertService,
                public globalService: GlobalService,
                private fileUploadService: UploadService) {
        super(http, alertService, globalService);
    }

    get(data): Observable<any> {
        return this.getRequest(AppUrl.ARTICLES_CATEGORY(), data);
    }

    detail(id): Observable<any> {
        return this.getRequest(AppUrl.ARTICLES_CATEGORY(id));
    }

    create(data): Observable<any> {
        return this.postRequest(AppUrl.ARTICLES_CATEGORY(), data);
    }

    update(id, data): Observable<any> {
        return this.putRequest(AppUrl.ARTICLES_CATEGORY(id), data);
    }

    updateStatus(id, data): Observable<any> {
        return this.putRequest(AppUrl.ARTICLES_CATEGORY_STATUS(id), data);
    }

    delete(id): Observable<any> {
        return this.deleteRequest(AppUrl.ARTICLES_CATEGORY_DELETE(id));
    }

    fileUploadAdmin(params, event): Observable<any> {
        return this.fileUploadService.fileUpload(AppUrl.FILE_UPLOAD_ADMIN(), params, event);
    }
}
